import { AxiosError } from "axios";
import { isObject } from "./isObject";

export function isAxiosError<T>(error: unknown): error is AxiosError<T> {
  return Boolean(isObject(error) && error.isAxiosError === true);
}
